// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shareListModalStyles } from "@insite/content-library/Components/ShareListModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

shareListModalStyles.shareListTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            margin-left: 5px;
        `,
        tooltipWrapper: css`
            margin-left: 5px;
        `,
        tooltipContainer: css`
            width: 500px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 290px;
                            margin-left: -270px;
                            &::after {
                                left: 270px;
                            }
                        `,
                    ],
                    "max",
                )}
        `,
        tooltipBody: css`
            padding: 5px;
        `,
    },
    typographyProps: {
        lineHeight: "16px",
    },
};

shareListModalStyles.cancelButtonGridItem = {
    width: [12, 3, 3, 3, 3],
    css: css`
        justify-content: flex-end;
    `,
};
shareListModalStyles.sendButtonGridItem = {
    width: [12, 3, 3, 3, 3],
    css: css`
        justify-content: flex-end;
    `,
};
